import { useContext, useMemo } from "react";
import { LocationControlSettingsContext } from "@contexts/location_control_settings_context.ts";
import LocationControl from "@grnhse/location-control";
import { type LocationType } from "@grnhse/location-control/dist/src/common/types";

export const useLocationControl = (granularLocationSearchEnabled: boolean) => {
  const { apiKey, provider, baseUrl, locationTypes } = useContext(LocationControlSettingsContext);

  return useMemo(() => {
    const types: LocationType[] = granularLocationSearchEnabled ? locationTypes : ["city"];
    return new LocationControl({ apiKey, provider, baseUrl, locationTypes: types });
  }, [apiKey, provider, baseUrl, locationTypes]);
};
